(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lead-hospitalization-disease', {
            parent: 'entity',
            url: '/lead-hospitalization-disease?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadHospitalizationDisease.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-hospitalization-disease/lead-hospitalization-diseases.html',
                    controller: 'LeadHospitalizationDiseaseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadHospitalizationDisease');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lead-hospitalization-disease-detail', {
            parent: 'entity',
            url: '/lead-hospitalization-disease/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadHospitalizationDisease.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-hospitalization-disease/lead-hospitalization-disease-detail.html',
                    controller: 'LeadHospitalizationDiseaseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadHospitalizationDisease');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LeadHospitalizationDisease', function($stateParams, LeadHospitalizationDisease) {
                    return LeadHospitalizationDisease.get({id : $stateParams.id});
                }]
            }
        })
        .state('lead-hospitalization-disease.new', {
            parent: 'lead-hospitalization-disease',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-hospitalization-disease/lead-hospitalization-disease-dialog.html',
                    controller: 'LeadHospitalizationDiseaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                comments: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lead-hospitalization-disease', null, { reload: true });
                }, function() {
                    $state.go('lead-hospitalization-disease');
                });
            }]
        })
        .state('lead-hospitalization-disease.edit', {
            parent: 'lead-hospitalization-disease',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-hospitalization-disease/lead-hospitalization-disease-dialog.html',
                    controller: 'LeadHospitalizationDiseaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LeadHospitalizationDisease', function(LeadHospitalizationDisease) {
                            return LeadHospitalizationDisease.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-hospitalization-disease', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lead-hospitalization-disease.delete', {
            parent: 'lead-hospitalization-disease',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-hospitalization-disease/lead-hospitalization-disease-delete-dialog.html',
                    controller: 'LeadHospitalizationDiseaseDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LeadHospitalizationDisease', function(LeadHospitalizationDisease) {
                            return LeadHospitalizationDisease.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-hospitalization-disease', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
